// React
import React, {Component} from 'react';
// Material
import {FormControl, Select, MenuItem, ListItemIcon, Checkbox, ListItemText, InputLabel} from '@material-ui/core';
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
// Styles
import {withStyles} from '@material-ui/core/styles';
import '../../styles.scss';
import './styles.scss'

const useStyles = {
    inputLabel: {
        color: '#565671',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '100%',
        display: 'ruby',
        textAlign: 'left'
    }
}

class SelectMultiple extends Component {
    render() {
        const {valueSelected, items, t, className, onSelect, label, classes, placeholder} = this.props;
        return (
            <FormControl className={`platform_select_simple ${className ?? 'select_primary'}`}>
                {
                    label &&
                    <InputLabel className={`${classes.inputLabel}`}>{placeholder}</InputLabel>
                }
                <Select
                    multiple
                    value={valueSelected}
                    onChange={onSelect}
                    renderValue={(selected) => {
                        return <span className={"ellipsis"}>
                            {selected.map((e, i) => {
                                var separator = ', ';
                                return <React.Fragment key={i}>
                                    {t(`commons:input.select.intents.params.${e}`)}
                                    {selected.length !== i + 1 && separator}
                                </React.Fragment>;
                            })}
                        </span>
                    }}
                    MenuProps={{
                        popoverclasses: className ?? 'select_primary',
                        getContentAnchorEl: null,
                        anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        },
                        style: {
                            maxHeight: 120 * 4.5,
                            width: '20ch',
                        }
                    }}
                    IconComponent={ExpandMoreIcon}
                >
                    <MenuItem disabled value="">
                        <em>{placeholder}</em>
                    </MenuItem>
                    {
                        items.map((item, i) => {
                            return (
                                <MenuItem key={i} value={item}>
                                    <ListItemIcon>
                                        <Checkbox checked={valueSelected.indexOf(item) > -1} />
                                    </ListItemIcon>
                                    <ListItemText primary={t(`commons:input.select.intents.params.${item}`)} />
                                </MenuItem>
                            )
                        })
                    }
                </Select>
            </FormControl>
        );
    }
}

export default withStyles(useStyles)(SelectMultiple);